(function(){
  // KAI sticky quick-buy bar.
  // Gotchas handled here (learned the hard way, do not remove):
  //  - element is MOVED to document.body (ancestor transform/filter breaks position:fixed),
  //    with dedupe so re-renders never stack two bars; skipped in the theme editor.
  //  - show threshold uses scrollY+innerHeight vs scrollHeight (footer offsets lie with parallax).
  //  - cart-drawer-open detection via computed overflow:hidden on body/html, not CSS classes.
  //  - always visible in Shopify.designMode; close is stored per session only.
  //  - flavour row is an infinite marquee: items are duplicated once, content drifts left and
  //    wraps seamlessly (out left, back in right). Clones stay clickable; selection is synced
  //    across copies via data-vid. Pauses on any user touch/scroll, respects reduced motion.
  function init(){
    var bar=document.querySelector('[data-kai-sticky]');
    if(!bar||bar.__kaiInit) return;
    bar.__kaiInit=true;
    var design=!!(window.Shopify&&window.Shopify.designMode);
    document.querySelectorAll('body > [data-kai-sticky]').forEach(function(n){ if(n!==bar){ n.parentNode.removeChild(n); } });
    if(!design&&bar.parentNode!==document.body){ document.body.appendChild(bar); }
    var KEY='kaiStickyClosed';
    try{ if(!design&&sessionStorage.getItem(KEY)){ bar.parentNode.removeChild(bar); return; } }catch(e){}
    bar.removeAttribute('hidden');
    var thr=(parseInt(bar.getAttribute('data-threshold')||'30',10)||30)/100;
    var items=[].slice.call(bar.querySelectorAll('.ksb-item'));
    var nameEl=bar.querySelector('.ksb-name'), priceEl=bar.querySelector('.ksb-price'), cta=bar.querySelector('.ksb-cta');
    if(!items.length||!cta) return;
    var box=bar.querySelector('.ksb-items');
    // ---- marquee setup: duplicate the row once for a seamless loop (before click binding) ----
    var marquee=false, period=0, g=8, sets=1;
    (function(){
      try{ if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; }catch(e){}
      if(!box||items.length<2) return;
      try{ g=parseFloat(getComputedStyle(box).columnGap)||8; }catch(e){}
      var orig=items.slice();
      function addSet(){
        var clones=orig.map(function(n){ return n.cloneNode(true); });
        clones.forEach(function(c){ box.appendChild(c); });
        items=items.concat(clones);
        sets++;
      }
      addSet();
      period=(box.scrollWidth+g)/sets;
      // Wide screens: keep adding sets until the loop can wrap before hitting the right edge.
      var guard=0;
      while(box.scrollWidth-box.clientWidth<period+40&&guard<5){ addSet(); guard++; }
      box.style.scrollSnapType='none';
      marquee=true;
    })();
    var ctaText=bar.getAttribute('data-cta')||'Add to Cart';
    var confirmText=bar.getAttribute('data-confirm')||'Added';
    var soldText=bar.getAttribute('data-soldout')||'Sold out';
    var cur=null;
    function select(it){
      if(!it) return;
      cur=it;
      var key=it.getAttribute('data-vid');
      items.forEach(function(b){ b.classList.toggle('sel',b.getAttribute('data-vid')===key); });
      if(nameEl){ nameEl.textContent=it.getAttribute('data-name')||''; }
      if(priceEl){ priceEl.textContent=it.getAttribute('data-price')||''; }
      var so=it.hasAttribute('data-soldout');
      cta.disabled=so;
      cta.textContent=so?soldText:ctaText;
    }
    items.forEach(function(b){ b.addEventListener('click',function(){ select(b); }); });
    select(items.filter(function(b){ return !b.hasAttribute('data-soldout'); })[0]||items[0]);
    cta.addEventListener('click',function(){
      if(!cur||cta.disabled) return;
      cta.disabled=true;
      cta.textContent='...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:parseInt(cur.getAttribute('data-vid'),10),quantity:1}]})})
        .then(function(r){ if(!r.ok){ throw new Error('add failed'); } return r.json(); })
        .then(function(){
          cta.textContent=confirmText;
          setTimeout(function(){ cta.textContent=ctaText; cta.disabled=false; },2200);
          // Small delay so the gift scripts (flavmap sweeper / kai-gift-auto) reconcile first.
          setTimeout(function(){
            if(window.kaiRefreshCart){ try{ window.kaiRefreshCart(); }catch(e){} }
            if(window.kaiOpenCart){ try{ window.kaiOpenCart(); }catch(e){} return; }
            try{ document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); }catch(e){}
            var tg=document.querySelector('button[aria-controls*="cart" i]')||document.querySelector('a[href$="/cart"]');
            if(tg){ tg.click(); }
          },400);
        })
        .catch(function(){ cta.textContent=ctaText; cta.disabled=false; });
    });
    var closeBtn=bar.querySelector('.ksb-close');
    if(closeBtn){
      closeBtn.addEventListener('click',function(){
        bar.classList.remove('on');
        if(!design){
          try{ sessionStorage.setItem(KEY,'1'); }catch(e){}
          setTimeout(function(){ if(bar.parentNode){ bar.parentNode.removeChild(bar); } },400);
        }
      });
    }
    function drawerOpen(){
      try{
        return getComputedStyle(document.body).overflow==='hidden'||getComputedStyle(document.documentElement).overflow==='hidden';
      }catch(e){ return false; }
    }
    function tick(){
      if(design){ bar.classList.add('on'); return; }
      if(drawerOpen()){ bar.classList.remove('on'); return; }
      var pct=(window.scrollY+window.innerHeight)/Math.max(document.documentElement.scrollHeight,1);
      bar.classList.toggle('on',pct>=thr);
    }
    window.addEventListener('scroll',tick,{passive:true});
    window.addEventListener('resize',tick,{passive:true});
    setInterval(tick,400);
    tick();
    // ---- marquee loop: drift left, wrap around the duplicated half ----
    if(marquee){
      var dir=1, pauseUntil=Date.now()+1500, pos=-1;
      var SPEED=0.5, IDLE=3500;
      function userPause(){ pauseUntil=Date.now()+IDLE; pos=-1; }
      ['pointerdown','touchstart','wheel'].forEach(function(ev){ box.addEventListener(ev,userPause,{passive:true}); });
      (function step(){
        window.requestAnimationFrame(step);
        if(!bar.classList.contains('on')) return;
        if(Date.now()<pauseUntil) return;
        period=(box.scrollWidth+g)/sets;
        if(period<10||box.scrollWidth-box.clientWidth<period) return;
        if(pos<0||Math.abs(box.scrollLeft-pos)>1.5){ pos=box.scrollLeft%period; }
        pos+=SPEED;
        if(pos>=period){ pos-=period; }
        box.scrollLeft=pos;
      })();
    }
  }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',init); }
  document.addEventListener('shopify:section:load',function(){ setTimeout(init,50); });
})();
